/**
 * access-management 模块接口
 */
/*
住宿生批量修改接口文档
https://note.youdao.com/web/#/file/recent/markdown/WEB6520a92c59f6e0b77eedae5a0c300c5a/adaca8ba06e6de662ba0e4fd25915241
*/

// 后台_通行码_接口文档:http://gitlab.10niu.cn/repository/editor?id=43&mod=524&itf=3479
// 宿舍管理v1.2.0 接口文档地址：http://rap2.10niu.cn/repository/editor?id=43&mod=572&itf=3771
// 宿舍批量删除逻辑_接口文档地址：http://rap2.10niu.cn/repository/editor?id=43&itf=4018
// 职工宿舍门禁_接口文档地址：http://rap2.10niu.cn/repository/editor?id=43&mod=572&itf=4126
// 宿舍管理v1.2.4：http://rap2.10niu.cn/organization/repository/editor?id=43&mod=634&itf=4128
import requestByGateway from '@/request/request.gateway';
import qs from 'qs';
import config from '@/config';
let jsonHeader = JSON.parse(JSON.stringify(config.headers));
jsonHeader['Content-Type'] = 'application/json';
const accessManagement = {
	/**
	 * 获取访客列表
	 */
	getVisitorList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取访客记录
	 */
	getVisitorRecord(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-record-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 检测是否开通并获取二维码
	 */
	getQRcode(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-system-status`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 刷新二维码
	 */
	refreshQRcode(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-update-qrcode`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取设备列表
	 */
	getDeviceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-device-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 删除设备
	 */
	deleteDevice(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/visitor-delete-devices`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 查询待添加的设备列表
	 */
	queryDeviceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-add-device-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 添加设备
	 */
	addDevices(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/visitor-add-device`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新设备信息
	 */
	updateDeviceInfo(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/visitor-update-device`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 修改人脸闸机控制
	 */
	getFaceGate(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-get-face-gate`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 修改人脸闸机控制
	 */
	changeFaceGate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/visitor-set-face-gate`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// ----[宿舍管理系统]-------------------------------------------------------------
	/**
	 * 导出学生
	 * 获取宿舍楼列表（筛选项）
	 */
	getBuildings(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/publics/v1/search-dormitory-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取宿舍房间列表（筛选项）
	 */
	getRooms(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/publics/v1/search-room-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取宿舍房间列表（筛选项）
	 */
	getPrinciples(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/publics/v1/search-dormitory-manager-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取人脸摄像头列表（筛选项）
	 */
	getCameraList(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.face
			}/console/v1/get-dormitory-face-camera-device-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取砸门设备列表（筛选项）
	 */
	getGateDeviceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get-dormitory-face-gate-device-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 添加管理员
	 */
	addDormPrinciple(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/batch-add-dormitory-staff`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 修改管理员
	 */
	editDormPrinciple(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/batch-update-dormitory-staff`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 添加设备
	 */
	addDormDevice(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/batch-update-dormitory-staff`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新设备
	 */
	editDormDevice(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/batch-update-dormitory-device`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取住宿生信息列表
	 */
	getBoarderList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get-dormitory-student-list-v2`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 导出住宿生信息列表
	 */
	exportStudentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/export-dormitory-student`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取单个住宿生的详细信息
	 */
	getBoarderDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get-dormitory-student-details`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 修改单个住宿生的详细信息
	 */
	setBoarder(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/update-dormitory-student-v2`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 修改单个住宿生的详细信息
	 */
	removeBoarder(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/delete-dormitory-student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取住宿房间信息列表
	 */
	getRoomList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get-dormitory-room-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 删除宿舍房间
	 */
	removeRoom(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/delete-dormitory-room`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取宿舍楼信息列表
	 */
	getDormList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get-dormitory-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取宿舍楼信息列表
	 */
	getDormDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get-dormitory-info-details`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 删除房间
	 */
	removeDorm(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/delete-dormitory`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 导出学生
	 */
	exportStudent(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/export-student`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 学生导入
	 */
	importStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/import-student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 住宿生信息列表
	 */
	importDormitoryStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/batch-update-dormitory-student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// ---------------记录
	/**
	 * 获取宿管记录
	 */
	getDormRecord(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/get-dormitory-history-lists`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	getRecordDevice(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/get-dormitory-device-keyword-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取宿管规则列表
	 */
	getRuleList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/get-dormitory-rule-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 删除宿管规则
	 */
	delRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/del-rule-dormitory`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 添加宿管规则
	 */
	addDormRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/add-dormitory-rule`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取宿管规则详情
	 */
	getDormRuleDetail(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/get-dormitory-rule-details`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新宿管规则
	 */
	updateDormRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/update-dormitory-rule`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取宿管规则重算状态
	 */
	getDormRuleComputed(data) {
		return requestByGateway({
			method: 'post',
			timeout: 1000 * 120,
			url: `${config.api.face}/console/v1/get-dormitory-recalculate-status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 宿管规则重算
	 */
	dormRuleRecomputed(data) {
		return requestByGateway({
			method: 'post',
			timeout: 1000 * 120,
			url: `${config.api.face}/console/v1/cgi-dormitory-recalculate`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *   门禁规则
	 *  */
	/**
	 * 获取支持门禁2.0设备列表
	 */
	getNewRuleDeviceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/device/v1/get_access_control_device_list`,
			headers: config.headers,
			params
		});
	},
	/**
	 *
	 * 获取职工职位列表
	 */
	getPositionList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/publics/v1/get_staff_position_by_school`,
			headers: config.headers,
			params
		});
	},
	/**
	 *
	 * 获取学生标签列表
	 */
	getStudentTagList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/publics/v1/get_student_table_by_school`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取门禁默认设置
	 */
	getRuleDefaultSet(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/device/v1/get_school_access_control_set`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 设置门禁默认设置
	 */
	setRuleDefaultSet(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/device/v1/set_access_control_default`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取门禁规则列表
	 */
	getEntranceRuleList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/device/v1/get_access_control_search_list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取门禁规则详情
	 */
	getEntranceRuleDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/device/v1/get_school_access_control_detail`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 添加门禁规则
	 */
	addEntranceRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/device/v1/access_control_create`,
			headers: jsonHeader,
			data: data
		});
	},
	/**
	 * 修改门禁规则
	 */
	editEntranceRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/device/v1/access_control_update`,
			headers: jsonHeader,
			data
		});
	},
	/**
	 * 删除门禁规则
	 */
	delEntranceRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/device/v1/access_control_delete`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取宿舍识别记录日志
	 */
	getDormDiscernLog(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/dormitory-history/img/lists`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取人脸库录入照片
	 */
	getFaceList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/publics/v1/face-db/list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 宿舍管理修改识别状态
	 */
	setDormDiscernStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${
				config.api.face
			}/console/v1/dormitory-history/update/identify/status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 宿舍管理--宿舍未归统计
	 */
	getStatisticsList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/dormitory/dormitory-statistics`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 宿舍管理_后台_根据宿舍获取学生状态记录(单个宿舍)
	 */
	getDormitoryRecord(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/dormitory/dormitory-record`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 宿舍管理_后台_根据宿舍统计宿舍楼学生人数(全部宿舍)
	 */
	getDormitoryStudentStatistics(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.face
			}/console/v1/dormitory/dormitory-student-statistics`,
			headers: config.headers,
			params
		});
	},
	// 后台_通行码_获取学校通行方式
	getAccessMode(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-pass-mode`,
			headers: config.headers,
			params
		});
	},
	//后台_通行码_获取访客来访详情
	getVisitorDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-detail`,
			headers: config.headers,
			params
		});
	},
	// 后台_通行码_下载访客模板
	tplDownload(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/download-visitor-template`,
			headers: config.headers,
			params
		});
	},
	// 后台_通行码_上传批量导入数据
	batchApply(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/visitor-batch-apply`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_通行码_获取导入结果
	getImportProcess(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/visitor-import-process`,
			headers: config.headers,
			params
		});
	},
	// 后台_宿舍进出管理规则列
	getInAndOutRuleList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get_in_and_out_rule_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_删除宿舍进出管理规则
	deleteInAndOutRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/delete_in_and_out_rule`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_获取宿舍进出管理规则详情
	getInAndOutRuleInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/console/v1/get_in_and_out_rule_info`,
			headers: config.headers,
			params
		});
	},
	// 后台_新增宿舍进出管理规则
	addInAndOutRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/add_in_and_out_rule`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_修改宿舍进出管理规则
	editInAndOutRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/edit_in_and_out_rule`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_批量删除住宿生信息
	removeRoomAll(data) {
		return requestByGateway({
			method: 'POST',
			url: `${config.api.face}/console/v1/batch-delete-dormitory-student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_规则_导出宿舍历史记录
	exportDormitoryHistoryLists(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/export-dormitory-history-lists`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_宿舍进出管理_获取学校职工职位列表
	schoolStaffList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/publics/v1/school-staff-position-list`,
			headers: config.headers,
			params
		});
	},
	// 添加/更新宿舍楼
	addDormitory(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/dormitory/v1/add_dormitory`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除宿舍楼
	delDormitory(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/dormitory/v1/del_dormitory`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 添加/更新宿舍房间
	addRoom(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/dormitory/v1/add_room`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除宿舍房间
	delRoom(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/dormitory/v1/del_room`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 批量添加宿舍楼
	addDormitoryBatch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/dormitory/v1/add_dormitory_batch`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 批量添加宿舍房间
	addRoomBatch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/dormitory/v1/add_room_batch`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default accessManagement;
